import { useEffect, useState } from 'react'
import { createModel } from 'hox'
import { homeService } from './homeService'
import useGlobalModel, { transPgToPagination } from '@/model/globalModel'
import { message } from 'antd'
import { applyListService } from '../apply/applyList/applyListService'
import { momentFormat } from '@/utils/utils'
import { ISCMApplyListFormFields } from '../apply/applyList/applyListTypes'
import { globalPrompt } from '@/components/message'
import { debounce } from 'lodash'
import { ISearchPage } from '@/types/AppTypes'
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE } from '@/utils/constants'
import { CommentOutlined } from '@ant-design/icons'
export interface INavOptions {
    id: string
    label: string
    value: string
    icon: string
    disabled?: boolean
}
const iconOptions: INavOptions[] = [
    // { id: '1', label: '首页', value: '/', icon: `<MessageOutlined  />` },
    { id: '2-1', label: '物资入库', value: '/manage/assetsEntry', icon: 'icon-jichushuju' },
    { id: '2-2', label: '物资领取', value: '/manage/assetsGet', icon: 'icon-jichushuju' },
    { id: '2-3', label: '物资归还', value: '/manage/assetsReturn', icon: 'icon-jichushuju' },
    { id: '2-4', label: '物资报废', value: '/manage/assetsAbandon', icon: 'icon-jichushuju' },
    { id: '2-5', label: '物资转移', value: '/manage/assetsMove', icon: 'icon-jichushuju' },
    { id: '2-7', label: '物资清理', value: '/manage/assetsClear', icon: 'icon-jichushuju' },
    { id: '2-6', label: '资产清单', value: '/manage/assetsList', icon: 'icon-jichushuju' },
    { id: '3-1', label: '资产盘点', value: '/inventory/assetsInventory', icon: 'icon-jichushuju' },
    // { id: '4-1', label: '数据字典', value: '/base/dict', icon: 'icon-jichushuju' },
    { id: '4-2', label: '物资档案', value: '/base/assetsArchives', icon: 'icon-jichushuju' },
    { id: '4-3', label: '仓库管理', value: '/base/warehouseManage', icon: 'icon-jichushuju' },
    { id: '4-4', label: '用户管理', value: '/base/userControl', icon: 'icon-jichushuju' },
    { id: '4-5', label: '组织机构', value: '/base/organization', icon: 'icon-jichushuju' },
    { id: '4-6', label: '资产分类', value: '/base/assetsClass', icon: 'icon-jichushuju' },
    { id: '4-7', label: '审批设置', value: '/base/assetsAsk', icon: 'icon-jichushuju' },
    { id: '5-1', label: '申请列表', value: '/apply/applyList', icon: 'icon-jichushuju' },
]
export const useHomerModal = createModel(function () {
    const {
        user: { shopId, userName, userCode, shopCode },
        user: listUser,
        fetchUserList,
        setLoadingInfo,
    } = useGlobalModel()
    const [loading, setLoading] = useState<boolean>(false)
    const [type, setType] = useState<string>('monthly') //日期信息
    const [visitData, setVisitData] = useState<any[]>([])
    const [shareData, setShareData] = useState<any[]>([])
    const [orgInsertData, setOrgInsertData] = useState<any[]>([])
    const [newOrgInsertData, setNewOrgInsertData] = useState<any[]>([])
    const [groupInsertData, setGroupInsertData] = useState<any[]>([])
    const [groupInserList, setGroupInserList] = useState<any[]>([])
    const [shareRes, setShareRes] = useState<any>({})
    const [employeeData, setEmployeeData] = useState<any[]>([])
    const [waitList, setWaitList] = useState<any[]>([])
    const [myCreatList, setMyCreatList] = useState<any>([])
    const [employeeValue, setEmployeeValue] = useState<string | undefined>(undefined)
    //编辑缓存
    const [editFormVal, setEditFormVal] = useState<any>({})
    const [getOneData, setGetOneData] = useState<any>({}) //单条查询name
    const [detialSelect, setDetialSelect] = useState<any>([]) //选择默认值
    const [nextApplyUser, setNextApplyUser] = useState<string>('') //下一级审批人
    const [applyVisible, setApplyVisible] = useState<boolean>(false) //下一级审批人
    const [applyHistoryList, setApplyHistoryList] = useState<any>([]) //审批记录
    const [dataSource, setDataSource] = useState<any[]>([])
    const [optionsList, setOptionsList] = useState<any[]>([])
    const [visible, setVisible] = useState<boolean>(false)
    const [checkValues, setCheckValues] = useState<string[]>([])
    const [noCheckValues, setNoCheckValues] = useState<any[]>([])
    const [navOptions, setNavOptions] = useState<INavOptions[]>(iconOptions)
    const [zichanzongshu, setZichanzongshu] = useState()
    const [zichanzonge, setZichanzonge] = useState()
    const [xianzhi, setXianzhi] = useState()
    const [baofei, setBaofei] = useState()
    //分页参数
    const initPgCfg: any = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<any>(initPgCfg)
    //查询条件
    const [searchParam, setSearchParam] = useState<any>({ status: "assets-status.leaveUnused" })
    const [applyDetailList, setApplyDetailList] = useState<any>([]);  //审批记录

    const setPage = async () => {
        let { retData } = await homeService.set({ userCode: userCode })

        setOptionsList(iconOptions)
        let newData = retData.map((item) => item.url)
        setCheckValues(newData)
        let newList = navOptions.filter((item) => !newData.includes(item.value)).map((item) => item.value)
        setNoCheckValues(newList)
    }
    const setUpdate = async () => {
        let newNavOptions = navOptions
            .filter((item) => checkValues.indexOf(item.value) !== -1)
            .map((item1) => {
                let { value, icon, label, id } = item1
                return {
                    path: id,
                    name: label,
                    url: value,
                    userCode: userCode,
                    icon: icon,
                }
            })
        let { retData } = await homeService.setUpdate({ userCode: userCode, details: newNavOptions })

        retData && setPage()
        return retData
    }
    // useEffect(() => {
    //     debugger
    //     allnum()
    // }, [])
    // 请求总数据
    const allnum = async () => {
        let { retData } = await homeService.allCount()
        let zichanzonge = retData.totalAmount
        let zichanzongshu = retData.totalNum
        let baofei = retData.totalDiscardNum
        let xianzhi = retData.totalLeaveUnusedNum
        setZichanzongshu(zichanzongshu)
        setZichanzonge(zichanzonge)
        setXianzhi(xianzhi)
        setBaofei(baofei)
        console.log(zichanzonge)
        // console.log(retData)
    }

    //列表查询
    const loadDataTable = async (page: ISearchPage = initPgCfg, searchValue: any = searchParam) => {
        const searchParams = {
            ...searchValue,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            // pageSize: 20,
            // pageNum: 1,
            type: 'assets.storage',
        }
        let { retData } = await homeService.page(searchParams)
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg))
        setDataSource(records)
    }
    //设置搜索value
    const updateSearchParam = (updateParam: any) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({})
        // setSelectedRowKeys([])
        loadDataTable(initPgCfg, {})
    }
    //访问量
    const loadWait = async () => {
        let { retData } = await homeService.loadWait({ userCode: userCode })
        setWaitList(retData ?? [])
    }
    //访问量
    const loadMyCreat = async () => {
        let { retData } = await applyListService.page({ pageNum: 1, pageSize: 20, createUser: userName, orderNum: 0 })
        const { records, ...pg } = retData
        setMyCreatList(records)
    }

    //新增管理公司统计
    const loadOrgInsert = async () => {
        homeService.useCount().then(({ retData }) => {
            let a: any = ['product']
            let b: any = []
            let newData: any = []
            retData.map((item: any) => {
                if (item.departmentName && a.includes(item.departmentName)) {
                    return
                } else {
                    a.push(item.departmentName)
                }
            })
            retData.map((item: any) => {
                if (item.typeName && b.includes(item.typeName)) {
                    return
                } else {
                    b.push(item.typeName)
                }
            })
            newData.push(a)
            b.map((item) => {
                let c: any = [item]
                retData.map((list: any) => {
                    if (list.typeName == item) {
                        c.push(list.num)
                    } else {
                        c.push(0)
                    }
                })
                newData.push(c)
            })
            setGroupInsertData(newData ?? [])
            let x: any = []
            let y: any = []
            let newList: any = []
            retData.map((item: any) => {
                if (item.typeName && x.includes(item.typeName)) {
                    return
                } else {
                    x.push(item.typeName)
                }
            })
            retData.map((item: any) => {
                if (item.departmentName && y.includes(item.departmentName)) {
                    return
                } else {
                    y.push(item.departmentName)
                }
            })
            newList.push(['product', ...x])
            y.map((item) => {
                let c: any = [item]
                x.map((element) => {
                    retData.map((list: any) => {
                        if (list.typeName == element && list.departmentName == item) {
                            c.push(list.num)
                        } else if (list.typeName !== element && list.departmentName == item) {
                            c.push(0)
                        }
                    })
                })
                newList.push(c)
            })
            // console.log(a)
            // console.log(b)
            // console.log(newData)
            setGroupInserList(newList ?? [])
        })
    }
    //名片新增分组统计
    const loadGroupInsert = async () => {
        homeService.statusCount().then(({ retData }) => {
            // var year = new Date().getFullYear()
            // let a = retData.find((item: any) => item.years == year)
            if (retData) {
                let newData = [
                    { value: retData.inUse, name: '在用' },
                    { value: retData.leaveUnused, name: '闲置' },
                    { value: retData.discard, name: '报废' },
                ]

                setOrgInsertData(newData ?? [])

                // let b:any=[]
                // let newList:any=[]
                // retData.map((item:any)=>{
                //     if(item.years&&b.includes(item.years)){return}
                //     else{b.push(item.years)}
                // })
                // newList.push(b)
                // let e:any=[]
                // let d:any=[]
                // let f:any=[]
                // retData.map((list:any)=>{
                //         e.push(list.inUse)
                //         d.push(list.leaveUnused)
                //         f.push(list.discard)
                // })
                // newList=[b,e,d,f]
                // setNewOrgInsertData(newList ?? [])
            }
        })
    }
    const zhupic = async () => {
        homeService.zhuzhunagtu().then(({ retData }) => {
            let newData = retData.map((item) => {
                return {
                    typeName: item.typeName,
                    value: item.num
                }
            })
            setNewOrgInsertData(newData ?? [])
        })
    }
    const loadData = async () => {
        setLoadingInfo({ loadingVisible: true, txt: '数据加载中...' })
        try {
            let res1 = await loadWait()
            let res2 = await handleEmployee()
            let res3 = await loadOrgInsert()
            let res4 = await loadGroupInsert()
            let res5 = await loadMyCreat()
            let res6 = await zhupic()
            setLoadingInfo({ loadingVisible: false, txt: '快速导入中' })
        } catch (err) {
            console.log(err)
            setLoadingInfo({ loadingVisible: false, txt: '快速导入中' })
        }
    }

    //分享人员变动
    const handleEmployee = () => {
        homeService.statisticsCount().then(({ retData }) => {
            setShareData(retData ?? [])
        })
    }
    //获取一条数据
    const getSDcDetailOne = async (id: string) => {
        let { retData } = await applyListService.one(id)
        let { processDetails, ...formVal } = retData
        if (retData) {
            // let fileList: any = []
            // const { md5, fileName } = formVal
            // if (md5) {
            //     fileList = [
            //         {
            //             uid: md5,
            //             status: 'done',
            //             name: fileName,
            //             response: {
            //                 retData: md5,
            //             },
            //         },
            //     ]
            // }
            // formVal.fileList = fileList
            setApplyDetailList(retData.details)
            const { fileList } = formVal
            if (fileList.length > 0) {
                formVal.fileList = fileList.map((list) => {
                    return {
                        uid: list.md5,
                        status: 'done',
                        name: list.fileName,
                        response: { retData: list.md5 },
                    }
                })
            }
            setEditFormVal({ ...formVal, createTime: momentFormat(formVal.createTime) ?? '' })
            fetchUserList(formVal.department)
            setGetOneData(retData.processDetails)
            let newList: any = []
            Object.keys(retData.processDetails).map((item) => {
                if (retData.processDetails[item][0].status) {
                    newList.push(item)
                }
            })
            setDetialSelect(newList)
            let logList: any = []
            Object.keys(retData.processDetails).map((item) => {
                retData.processDetails[item].map((list) => {
                    if (list.isReviewer && list.isApprove) {
                        logList.push(list)
                    }
                })
            })
            setApplyHistoryList(logList)
        }
        return retData
    }
    //审批操作
    const onApply = (row) => {
        getSDcDetailOne(row.id).then((retData) => {
            let newName: string = ''
            Object.keys(retData.processDetails).map((item) => {
                if (newName) {
                    return
                } else if (retData.processDetails[item].find((list) => !list.isApprove && list.status)) {
                    newName = item
                    return
                }
            })
            setNextApplyUser(newName)
            // console.log(newName)
            // console.log(retData.processDetails)
            // debugger
            // if(retData.processDetails[newName].find((list)=>list.user==userName)){
            // 	setApplyVisible(true)
            // }
            // else{
            // 	message.warning('您无此条单据的审批权限')
            // }
            let newList: any = []
            Object.keys(retData.processDetails).map((item) => {
                retData.processDetails[item].map((list) => {
                    if (list.isReviewer && list.isApprove) {
                        newList.push(list)
                    }
                })
            })
            setApplyVisible(true)
            setApplyHistoryList(newList)
        })
    }
    // 关闭此条
    const onClose = async (row) => {
        if (row.status == 'assets-apply-status.audit') {
            globalPrompt('message', { text: '请选择已审核或已驳回的申请单据！', type: 'warning' })
            return
        }
        globalPrompt('modal', {
            title: '关闭',
            type: 'warning',
            text: '您是否关闭此条申请单据？',
            okText: '确认',
            onOk: debounce(async () => {
                try {
                    let result = await applyListService.updateOrderNum({ id: row.id, orderNum: 1 })
                    result && message.success('申请单据关闭成功！')
                    loadData()
                } catch {
                    message.error('申请单据关闭失败！')
                }
            }, 500),
            cancelText: '取消',
            onCancel: () => { },
        })
    }
    return {
        /***field***/
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadDataTable,
        optionsList,
        setPage,
        visible,
        setVisible,
        checkValues,
        setCheckValues,
        navOptions,
        setNavOptions,
        setUpdate,
        loading,
        visitData,
        shareRes,
        orgInsertData,
        groupInsertData,
        employeeData,
        employeeValue,
        handleEmployee,
        shareData,
        waitList,
        loadWait,
        loadOrgInsert,
        loadGroupInsert,
        loadData,
        type,
        setType,
        newOrgInsertData,
        setNewOrgInsertData,
        groupInserList,
        setGroupInserList,
        editFormVal,
        setEditFormVal,
        getOneData,
        setGetOneData,
        detialSelect,
        setDetialSelect,
        nextApplyUser,
        setNextApplyUser,
        applyVisible,
        setApplyVisible,
        applyHistoryList,
        setApplyHistoryList,
        onApply,
        getSDcDetailOne,
        myCreatList,
        setMyCreatList,
        onClose,
        dataSource,
        setDataSource,
        zichanzongshu,
        setZichanzongshu,
        zichanzonge,
        setZichanzonge,
        xianzhi,
        setXianzhi,
        baofei,
        setBaofei,
        zhupic,
        noCheckValues,
        setNoCheckValues,
        allnum,
        pgCfg,
        setPgCfg,
        applyDetailList,
        setApplyDetailList
    }
})
